module.exports = __webpack_public_path__ + "img/icon-send-03.svg";